export default {
  namespace: "activeId",
  state: "",
  reducers: {
    storage(state, { payload }) {
      return payload;
    },
  },
};
